import React from 'react'
import { Button, Box, Grid , Typography} from '@mui/material'
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
import VehicleButton from '../../../components/MasterFile/VehicleHomeMaster/VehicleButton'
import { useNavigate } from 'react-router-dom';
import buttonStyle from '../../../styles/buttonStyle'

function CustomColumnMenu(props) {
  return (
      <GridColumnMenu
          {...props}
          slots={{
              // Hide `columnMenuColumnsItem`
              columnMenuColumnsItem: null,
              columnMenuSortItem: null,
          }}
      />
  );
}
const columns = [

  { field: 'id', headerName: 'No', editable: false, sortable: false, minWidth: 100 },
  { field: 'VRM', headerName: 'VRM', editable: false, sortable: false, minWidth: 100},
  { field: 'Make', headerName: 'Make', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Model', headerName: 'Model', editable: false, sortable: false, flex: 1 , minWidth: 100},
  { field: 'Mfr_Date', headerName: 'Mfr Date', editable: false, sortable: false,  minWidth: 100},
  { field: 'First_Used', headerName: 'First Used', editable: false, sortable: false, minWidth: 100 },
  { field: 'Last_Service', headerName: 'Last Service', editable: false, sortable: false, minWidth: 100 },
  { field: 'Engine', headerName: 'Engine', editable: false, sortable: false,minWidth: 100 },
  { field: 'Gear_Type', headerName: 'Net Total', editable: false, sortable: false, minWidth: 100},
  { field: 'Fleet_No', headerName: 'Fleet No', editable: false, sortable: false,minWidth: 100 },
  { field: 'MOT', headerName: 'MOT', editable: false, sortable: false,minWidth: 100 },
  { field: 'MOT_Due', headerName: 'MOT_Due', editable: false, sortable: false,minWidth: 100 },
  { field: 'Owner', headerName: 'Owner', editable: false, sortable: false,flex: 1, minWidth: 100 },
  { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 180, renderCell: () => {
    return (
    <VehicleButton/>
    );
    }}
];

 

const rows = [

  { id: 1251, VRM: 'K88FEN', Make: 'Ford',  Model: 'Ford Fiesta Edge 60', Mfr_Date:'10-01-2021', First_Used:'10-05-2021',Last_Service:'10-8-2021', Engine:'Petrol', Gear_Type: 'Manual',Fleet_No: '',	MOT:'10-01-2022',	MOT_Due:'20-01-2022',	Owner:'James Anderson'},
  { id: 1252, VRM: 'SV61OXE', Make: 'AUDI',  Model: 'A5 S LINE BLACK EDIT TDI QUAT', Mfr_Date:'25-05-2020', First_Used:'25-10-2020',Last_Service:'25-01-2021',  Engine:'Diesel', Gear_Type: 'Manual',Fleet_No: '',	MOT:'25-05-2021',	MOT_Due:'02-06-2021',	Owner:'Antony Wilson'},
  { id: 1253, VRM: 'CY17EWF', Make: 'VOLKSWAGEN', Model: 'POLO MATCH EDITION TSI', Mfr_Date:'05-05-2021', First_Used:'10-10-2021',Last_Service:'10-12-2021',  Engine:'Petrol', Gear_Type: 'Manual',Fleet_No: '',	MOT:'10-10-2022',	MOT_Due:'21-10-2022',	Owner:'Emma Moore'},
  { id: 1254, VRM: 'SA17BEY', Make: 'VAUXHALL', Model: 'INSIGNIA SRI VX-LINE CDTI S/S', Mfr_Date:'17-04-2019', First_Used:'18-10-2020',Last_Service:'10-8-2021',  Engine:'Diesel', Gear_Type: 'Manual',Fleet_No: '',	MOT:'18-10-2021',	MOT_Due:'30-10-2021',	Owner:'Andrew Moffatt'},
  { id: 1255, VRM: 'VO13VOB', Make: 'AUDI',  Model: 'Q3 SE TDI', Mfr_Date:'05-09-2019', First_Used:'01-01-2020',Last_Service:'02-03-2021',  Engine:'Diesel', Gear_Type: 'Manual',Fleet_No: '',	MOT:'01-01-2021',	MOT_Due:'15-01-2021',	Owner:'Jade Mccheyne'},
  { id: 1256, VRM: 'CV17DZZ', Make: 'FORD',  Model: 'ECOSPORT TITANIUM S', Mfr_Date:'20-01-2019', First_Used:'22-06-2020', Last_Service:'23-08-2021', Engine:'Petrol', Gear_Type: 'Manual',Fleet_No: '',	MOT:'22-07-2021',	MOT_Due:'30-07-2021',	Owner:'Bradley O connell'},
  { id: 1257, VRM: 'MW14EWR', Make: 'FORD',  Model: 'FIESTA ZETEC S', Mfr_Date:'14-08-2020', First_Used:'14-03-2021',Last_Service:'14-05-2021',  Engine:'Petrol', Gear_Type: 'Manual',Fleet_No: '',	MOT:'14-03-2022',	MOT_Due:'25-03-2022',	Owner:'Gareth Walker'},
  { id: 1258, VRM: 'YE61SWU', Make: 'BMW',  Model: '320D SPORT AUTO', Mfr_Date:'11-10-2020', First_Used:'11-05-2021',Last_Service:'11-08-2021',  Engine:'Diesel', Gear_Type: 'Manual',Fleet_No: '',	MOT:'11-05-2022',	MOT_Due:'20-05-2022',	Owner:'Craig Rice'},
  { id: 1259, VRM: 'SP63OTM', Make: 'MINI',  Model: 'COOPER D', Mfr_Date:'05-05-2019', First_Used:'05-01-2020',Last_Service:'05-03-2021',  Engine:'Diesel', Gear_Type: 'Manual',Fleet_No: '',	MOT:'05-01-2021',	MOT_Due:'15-01-2021',	Owner:'Paul Mc Cann'},
  { id: 1260, VRM: 'LM66LUD', Make: 'MERCEDES-BENZ',  Model: 'C250 D AMG LINE AUTO', Mfr_Date:'01-09-2020', First_Used:'02-02-2021',Last_Service:'20-04-2021',  Engine:'Diesel', Gear_Type: 'Manual',Fleet_No: '',	MOT:'02-02-2022',	MOT_Due:'15-02-2022',	Owner:'Joshua Bullen'},
  ];
function VehicleHome() {
  const navigate = useNavigate()
return (
  <Box mt={2}>
    <Grid container spacing={1}>
      <Grid item xs={12} >
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}> VEHICLE DETAILS</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end' >
            <Button sx={buttonStyle.root} onClick={() => navigate('/Add_Vechicle')}>Vehicle Update</Button>
        </Grid>
      </Grid>
        </Grid>
          <Grid item xs={12} mt={1}>
            <Box sx={dataGridStyle.root}>
              <DataGrid
              columnHeaderHeight={42}
              rowHeight={40}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[10]}
              slots={{ columnMenu: CustomColumnMenu }}
              disableRowSelectionOnClick
              />
            </Box>
          </Grid>
        </Grid>
    </Box>
  )
}

export default VehicleHome